import { StatisticsService } from '@common/ApiService'
import { s3FileOpener } from '@utils/file-opener'

const UPDATE_DATA_TRACKINGS = 'DATA_TRACKINGS_SUCCESS'
const FETCH_ERROR = 'FETCH_ERROR'
const UPDATE_PROGRESS = 'UPDATE_PROGRESS'
const UPDATE_BROWSERS_LIST = 'UPDATE_BROWSERS_LIST'
const STATISTICS_REPORT_TYPES = 'STATISTICS_REPORT_TYPES'
const STATISTICS_REPORT_ERROR = 'STATISTICS_REPORT_ERROR'

export const state = {
  data_trackings: {},
  browsers_list: [],
  errors: {},
  progress: '',
  statistics_report_types: [],
}

export const mutations = {
  [UPDATE_DATA_TRACKINGS](state, payload) {
    state.data_trackings = payload
    state.progress = 'success'
    return state
  },

  [UPDATE_BROWSERS_LIST](state, payload) {
    state.browsers_list = payload
    return state
  },

  [FETCH_ERROR](state, data) {
    state.errors = data
    state.progress = 'error'
    return state.errors
  },

  [UPDATE_PROGRESS](state, progress) {
    state.progress = progress
    return state.progress
  },

  [STATISTICS_REPORT_TYPES](state, data) {
    state.statistics_report_types = data
  },

  [STATISTICS_REPORT_ERROR](state, error) {
    state.statistics_report_types = error
  },
}

export const actions = {
  fetchDataDeclinedTrackings({ commit }, query) {
    return new Promise((resolve) => {
      commit(UPDATE_PROGRESS, 'search_loading')
      return StatisticsService.retrieveDataTrackings(query)
        .then((response) => {
          commit(UPDATE_DATA_TRACKINGS, response.data)
          commit(UPDATE_PROGRESS, 'data_trackings_success')
          resolve(response.data)
        })
        .catch((error) => commit(FETCH_ERROR, error))
    })
  },

  fetchBrowsersList({ commit }) {
    return new Promise((resolve) => {
      return StatisticsService.retrieveBrowsersList()
        .then((response) => {
          commit(UPDATE_BROWSERS_LIST, response.data)
          resolve(response.data)
        })
        .catch((error) => commit(FETCH_ERROR, error))
    })
  },

  async fetchStatisticsReportsTypes({ commit }) {
    return new Promise((resolve) => {
      return StatisticsService.retrieveStatisticsReportTypes().then(
        (response) => {
          commit(STATISTICS_REPORT_TYPES, response.data)
          resolve(response.data)
        }
      )
    })
  },

  generateReport(_, params) {
    return StatisticsService.generate({
      params,
    })
  },

  downloadStatisticsReport(_, { link }) {
    return s3FileOpener(link)
  },
}
